import React from 'react'
import { SuggestedMatch } from '@Entities/matching/suggested-match'
import './index.scss'
import day from 'dayjs'

interface SuggestedMatchMetadataProps {
    suggestedMatch: SuggestedMatch
}

const SuggestedMatchMetadata = (props: SuggestedMatchMetadataProps) => {
    const { suggestedMatch } = props

    const totalRecordingGroupsCount = () => {
        if (suggestedMatch) {
            return (
                suggestedMatch?.recordingGroupsApproved +
                suggestedMatch.recordingGroupsSuperseded +
                suggestedMatch.recordingGroupsSubmitted +
                suggestedMatch.recordingGroupsRejected
            )
        }
        return 0
    }

    return (
        <section className="suggested-match-metadata">
            <p>
                <span>Submission Date:</span>
                <strong>
                    {day(suggestedMatch.submissionTimestamp, 'YYYY-MM-DD HH:mm:ss ZZ')
                        .toDate()
                        .toLocaleString('default', { month: 'short', day: 'numeric', year: 'numeric' })}
                </strong>
            </p>
            <p>
                <span>Submission User:</span>
                <strong>{props.suggestedMatch.submittingUserName}</strong>
            </p>
            <p>
                <span>Song Code:</span>
                <strong>{props.suggestedMatch.currentSongCode}</strong>
            </p>
            <p>
                <span>Song Writers:</span>
                <strong>
                    {props.suggestedMatch.workWriters && props.suggestedMatch.workWriters.split('|').join(', ')}
                </strong>
            </p>
            <p className="total-recording-group-count">
                <span>Total Recording Groups:</span>
                <strong>{totalRecordingGroupsCount()}</strong>
            </p>
        </section>
    )
}

export default SuggestedMatchMetadata
